var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidaysIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 50.4231H48.6154C46.6161 50.4231 44.6986 49.6288 43.2849 48.2151C41.8712 46.8014 41.0769 44.884 41.0769 42.8848C41.0769 44.884 40.2827 46.8014 38.869 48.2151C37.4552 49.6288 35.5378 50.4231 33.5385 50.4231C31.5391 50.4231 29.6217 49.6288 28.208 48.2151C26.7942 46.8014 26 44.884 26 42.8848C26 44.884 25.2058 46.8014 23.792 48.2151C22.3783 49.6288 20.4609 50.4231 18.4615 50.4231C16.4622 50.4231 14.5448 49.6288 13.131 48.2151C11.7173 46.8014 10.9231 44.884 10.9231 42.8848C10.9231 44.884 10.1288 46.8014 8.71511 48.2151C7.30138 49.6288 5.38394 50.4231 3.38462 50.4231H1.5",
    stroke: "#8AD0F4",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3076 35.3476C35.3663 32.9875 32.9264 31.0867 30.1632 29.7817C27.3999 28.4766 24.3819 27.7998 21.326 27.7998C18.2701 27.7998 15.2521 28.4766 12.4889 29.7817C9.72562 31.0867 7.28573 32.9875 5.34448 35.3476",
    stroke: "#00A3FA",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.115 27.9977C24.3411 19.4794 26.9419 11.7149 32.5958 8.92578",
    stroke: "#00A3FA",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3274 1.76039C23.7707 1.27929 26.3055 1.75384 28.4093 3.08622C30.5132 4.41861 32.0257 6.50729 32.6351 8.92177",
    stroke: "#00A3FA",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3918 10.3184C44.657 8.44527 42.298 7.26991 39.7578 7.01312C37.2176 6.75633 34.6711 7.43578 32.5964 8.92385",
    stroke: "#00A3FA",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7634 12.9541C20.2404 10.7782 22.4296 9.18513 24.9544 8.44904C27.4792 7.71296 30.1815 7.87989 32.5965 8.92113C35.0189 9.51354 37.1161 11.0242 38.4454 13.1341C39.7746 15.244 40.2318 17.7879 39.7204 20.2286",
    stroke: "#00A3FA",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidaysIcon);
export default __webpack_public_path__ + "static/media/holidays-icon.e5b582ecc862c0ee813e726835b5d9de.svg";
export { ForwardRef as ReactComponent };